module.exports = __webpack_public_path__ + "fonts/tiempos-headline-semibold.acbe220.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/TiemposHeadline/tiempos-headline-semibold.woff
// module id = 287
// module chunks = 245 246